<template>
  <section class="cta-five">
    <div class="container">
      <div class="cta-five__sliders">
        <!-- Slider da esquerda -->
        <div class="cta-five__slider">
          <div class="cta-five__wrapper" :style="wrapperStyleLeft">
            <div class="cta-five__item" v-for="(item, index) in itemsLeft" :key="`left-${index}`">
              <component
                :is="item.link.startsWith('http') ? 'a' : 'router-link'"
                :href="item.link.startsWith('http') ? item.link : null"
                :to="!item.link.startsWith('http') ? item.link : null"
                :target="item.link.startsWith('http') ? '_blank' : null"
                rel="noopener noreferrer"
              >
                <img :src="item.image" alt="Slide Image" />
              </component>
            </div>
          </div>
        </div>

        <!-- Slider da direita -->
        <div class="cta-five__slider">
          <div class="cta-five__wrapper" :style="wrapperStyleRight">
            <div class="cta-five__item" v-for="(item, index) in itemsRight" :key="`right-${index}`">
              <component
                :is="item.link.startsWith('http') ? 'a' : 'router-link'"
                :href="item.link.startsWith('http') ? item.link : null"
                :to="!item.link.startsWith('http') ? item.link : null"
                :target="item.link.startsWith('http') ? '_blank' : null"
                rel="noopener noreferrer"
              >
                <img :src="item.image" alt="Slide Image" />
              </component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "CtaFive",
  data() {
    return {
      currentIndexLeft: 0,
      currentIndexRight: 0,
      timerLeft: null,
      timerRight: null,
    };
  },
  computed: {
    ...mapGetters({
      startData: 'general/getStartData',
    }),
    itemsLeft() {
      if (!this.startData || !this.startData.banners) return [];
      return this.startData.banners
        .filter(b => b.tipo_id === 3 && b.imagem && b.imagem.url)
        .map(b => ({
          image: b.imagem.url,
          link: b.link || '#',
        }));
    },
    itemsRight() {
      if (!this.startData || !this.startData.banners) return [];
      return this.startData.banners
        .filter(b => b.tipo_id === 4 && b.imagem && b.imagem.url)
        .map(b => ({
          image: b.imagem.url,
          link: b.link || '#',
        }));
    },
    wrapperStyleLeft() {
      const translateX = -this.currentIndexLeft * 100;
      return {
        transform: `translateX(${translateX}%)`,
        transition: "transform 0.5s ease-in-out",
      };
    },
    wrapperStyleRight() {
      const translateX = -this.currentIndexRight * 100;
      return {
        transform: `translateX(${translateX}%)`,
        transition: "transform 0.5s ease-in-out",
      };
    },
  },
  methods: {
    nextSlideLeft() {
      if (this.itemsLeft.length > 0) {
        this.currentIndexLeft = (this.currentIndexLeft + 1) % this.itemsLeft.length;
      }
    },
    nextSlideRight() {
      if (this.itemsRight.length > 0) {
        this.currentIndexRight = (this.currentIndexRight + 1) % this.itemsRight.length;
      }
    },
    startAutoSlide() {
      this.timerLeft = setInterval(() => {
        this.nextSlideLeft();
      }, 5000);

      this.timerRight = setInterval(() => {
        this.nextSlideRight();
      }, 5300);
    },
  },
  mounted() {
    this.startAutoSlide();
  },
  beforeDestroy() {
    clearInterval(this.timerLeft);
    clearInterval(this.timerRight);
  },
};
</script>

<style scoped>
.cta-five {
  display: flex;
  justify-content: center;
}

.container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;

}

.cta-five__sliders {
  display: flex;
  gap: 20px;
}

.cta-five__slider {
  position: relative;
  overflow: hidden;
  flex: 1;

}

.cta-five__wrapper {
  display: flex;
  transition: transform 0.5s ease-in-out;
  will-change: transform;
}

.cta-five__item {
  flex: 0 0 100%;
  box-sizing: border-box;
  cursor: pointer;
}

.cta-five__item img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 15px;
  border: 1px solid red;
}

@media (max-width: 768px) {
  .cta-five__sliders {
    flex-direction: column;
    gap: 20px;
  }

  .cta-five__slider {
    width: 100%;
  }

  .cta-five__item {
    padding: 0;
  }
}
</style>